require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./ar-eg-project-مصر.json") })
        }
      }, "path---ar-eg-project-مصر");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---ar-eg-project-مصر!./.cache/json/ar-eg-project-مصر.json
// module id = 439
// module chunks = 231608221292675